import React from 'react';

import { IconProps } from '../DefaultIcon';

export function GoodhabitzIcon({ className }: IconProps) {
  return (
    <svg
      width="59"
      height="87"
      viewBox="0 0 59 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M58.2505 9.32624C58.2529 4.96177 54.9397 1.31481 50.6089 0.914449C46.2777 0.514052 42.3564 3.49219 41.5638 7.78375C31.6675 -0.380222 17.2586 0.140675 7.97326 8.99813C-1.31209 17.8557 -2.55998 32.2697 5.06413 42.6013C12.6882 52.9329 26.7917 55.9394 37.9429 49.6104C49.094 43.2814 53.7932 29.6029 48.8982 17.7225C49.2069 17.7403 49.5162 17.7403 49.8252 17.7225C54.453 17.716 58.2121 13.9702 58.2505 9.32624ZM49.8252 4.76919C52.3332 4.76919 54.3666 6.80949 54.3666 9.32624C54.3666 11.8434 52.3332 13.8836 49.8252 13.8836C47.3169 13.8836 45.2838 11.8434 45.2838 9.32624C45.2838 6.80949 47.3169 4.76919 49.8252 4.76919ZM25.4522 41.1796C17.889 41.1796 11.7578 35.0269 11.7578 27.4374C11.7578 19.8476 17.889 13.6952 25.4522 13.6952C33.0154 13.6952 39.1467 19.8476 39.1467 27.4374C39.1337 35.0218 33.01 41.1666 25.4522 41.1796Z"
        fill="#00416B"
      />
      <path
        d="M25.4524 86.1747C39.456 86.1552 50.8033 74.7682 50.8229 60.7158H39.088C39.088 68.3053 32.9569 74.458 25.3937 74.458C17.8305 74.458 11.6994 68.3053 11.6994 60.7158H0.0820312C0.101422 74.7682 11.4488 86.1552 25.4524 86.1747Z"
        fill="#00416B"
      />
    </svg>
  );
}
